import type { DropdownOption, TimeBreakdown } from './types';

export const getSelectedOptionByTimeBreakdown = (
	options: DropdownOption[],
	timeBreakdown?: TimeBreakdown,
): DropdownOption => {
	const idx = options.findIndex((option) => option.id === timeBreakdown);
	return options[idx];
};
